import { Route,  Routes } from 'react-router-dom';
import './App.css';
import {Result} from './components/Result';
import { TheStartlist } from './components/TheStartlist';
import { Dashboard } from './components/Dashboard';

function App() {
  return (
    <div className="App">
      <div>
          <Routes>
            <Route index element={<Dashboard />} />
            <Route path="result">
              <Route path=':date/:trackId/:raceNumber' element={<Result />} />
            </Route>
            <Route path="startlist">
              <Route path=':date/:trackId/:raceNumber/:bettype/:theme' element={<TheStartlist />} />
            </Route>
          </Routes>
      </div>
    </div>
  );
}

export default App;
